<template>
    <div class="project-head">
        <div class="username">{{ username }}</div>
        /
        <div class="project">{{ projectName }}</div>
    </div>
</template>

<style scoped>
    .project-head {
        display: flex;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .username {
        font-size: 16px;
        padding-right: 4px;
    }

    .project {
        font-size: 16px;
        font-weight: 600;
        padding-left: 4px;
    }
</style>

<script>
    import Vue from 'vue';

    // noinspection JSCheckFunctionSignatures
    export default Vue.extend({
        name: 'project-head',
        props: {
            username: { type: String, required: true },
            projectName: { type: String, required: true },
        },
    });
</script>
